var _a;
import TaskTypes from 'src/enums/TaskTypes';
var taskTypeToIconMap = (_a = {},
    _a[TaskTypes.WATCH_VIDEO] = 'ondemand_video',
    _a[TaskTypes.OPERATIONAL] = 'build_circle',
    _a[TaskTypes.GOVERNANCE] = 'support',
    _a);
export default taskTypeToIconMap;



//////////////////
// WEBPACK FOOTER
// ./src/maps/taskTypeToIconMap.ts
// module id = 831
// module chunks = 81